import React from 'react';
import cn from 'classnames';

import { formatNumber } from '../../util';

import styles from './styles.module.scss';

type status = 'normal' | 'active' | 'disabled';

interface Props {
  store: string;
  description: string;
  point: number;
  status?: status;
  onClick?(): void;
  className?: string;
}

const PointItem: React.FC<Props> = (props) => {
  const { store, description, point, onClick, className, status = 'normal' } = props;

  const statusClass = {
    normal: null,
    active: styles.active,
    disabled: styles.disabled,
  }[status];

  return (
    <div className={cn(styles.pointItem, statusClass, className)} onClick={onClick} data-id={`btn_point_item_${store}`}>
      <div className={cn(styles.storeDescription)}>
        <p className={styles.store}>{store}</p>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={cn(styles.pointDescription)}>
        <span className={styles.number}>{formatNumber(point)}</span>
        <span className={styles.point}>P</span>
      </div>
    </div>
  );
};

export default PointItem;
